module.exports = __webpack_public_path__ + "static/media/MEDICAL.a0c9e5a9.svg";